<template>
  <b-modal
      id="modal-config-imagem"
      cancel-variant="outline-secondary"
      ok-title="Salvar"
      cancel-title="Cancelar"
      centered
      title="Configurar Imagem"
      size="xl"
      @ok="saveImagem(currentImage)"
      :ok-disabled="!currentImage.caminho"
      @cancel="resetData"
      @close="resetData"
      no-close-on-esc
      no-close-on-backdrop
  >
    <b-form ref="refFormAddImagem">
      <b-row>
        <b-col cols="12" sm="6">
          <b-row class="justify-content-between ">
            <b-col cols="12" sm="6">
              <b-form-group>
                <validation-provider
                    #default="{ errors }"
                    name="Imagem principal"
                >
                  <b-form-checkbox
                      v-model="currentImage.imagem_principal"
                      :value="1"
                      :unchecked-value="0"
                  >
                    Imagem principal
                  </b-form-checkbox>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6">
              <b-form-group>
                <validation-provider
                    #default="{ errors }"
                    name="Exibe Cores"
                >
                  <b-form-checkbox
                      v-model="currentImage.exibe_cores"
                      :value="1"
                      :unchecked-value="0"
                  >
                    Exibe Cores
                  </b-form-checkbox>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </b-col>
            <b-col cols="12" sm="6">
              <b-form-group label="Ordem">
                <validation-provider
                    #default="{ errors }"
                    name="Ordem"
                    rules="required"
                >
                  <b-form-select
                      v-model="currentImage.ordem"
                      text-field="text"
                      plain
                      :state="errors.length > 0 ? false:null"
                      value-field="value"
                      :options="[
                      { text: 'Selecione uma ordem', value: null, disabled: true },
                      { text: '1', value: 1 },
                      { text: '2', value: 2 },
                      { text: '3', value: 3 },
                      { text: '4', value: 4 },
                      { text: '5', value: 5 },
                  ]"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6">
              <b-form-group label="Embalagem">
                <validation-provider
                    #default="{ errors }"
                    name="Embalagem"
                    rules="required"
                >
                  <v-select
                      id="select-embalagem"
                      name="select-embalagem"
                      v-model="currentImage.cdn_embalag"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :class="{ 'border-danger border-round': errors.length > 0 }"
                      :options="embalagens"
                      label="des_embalag"
                      @search="listarEmbalagens"
                      key="cdn_embalag"
                      :loading="$store.getters['slsTemplateImagem/getIsLoading']"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" sm="4">
              <b-form-group label="Código da cor">
                <b-input-group>
                  <b-form-input placeholder="Digite o código da cor..." v-model="cod_cor"/>
                  <b-input-group-append>
                    <b-button variant="outline-primary" @click="searchCor()" v-b-tooltip.hover.top="'Definir cor'">
                      <feather-icon icon="CheckIcon"/>
                    </b-button>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-button variant="outline-primary" @click="showCollapse = !showCollapse" v-b-tooltip.hover.top="'Procurar cores'" :disabled="isEditarForm">
                      <feather-icon icon="SearchIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="8" class="mt-2" align-self="end">
              <b-form-group
                  label-for="readOnlyInput"
              >
                <b-form-input
                    id="readOnlyInput"
                    v-model="nameColor"
                    :state="nameColor === 'Cor não encontrada' ? false:null"
                    :style="{
                      color: nameColor === 'Cor não encontrada' ? 'red' : 'black',
                    }"
                    readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12" v-if="showCollapse">
              <app-collapse accordion>
                <app-collapse-item title="Lista de Cores" is-visible class-header-collapse="bg-gray">
                  <b-row>
                    <b-col cols="12">
                      <b-form-group label="Pesquisar">
                        <b-input-group>
                          <b-form-input placeholder="Digite o código da cor..." v-model="searchColor"
                            @input="listarCores()" />
                            <b-input-group-append>
                              <b-button variant="outline-danger" @click="searchColor = ''" v-b-tooltip.hover.top="'Limpar filto'">
                                <feather-icon icon="TrashIcon" />
                              </b-button>
                            </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <div v-if="!searchColor || searchColor.trim() === ''" class="text-center my-4">
                        <feather-icon icon="InfoIcon" size="24" class="text-muted mb-1"></feather-icon>
                        <h6 class="text-muted">Digite o código ou descrição da cor para pesquisar</h6>
                      </div>

                      <div v-else>
                        <b-table :busy="colorLoading" :striped="true" :bordered="true" :hover="true"
                          :responsive="true" ref="refTableColor" table-variant="secondary"
                          :per-page="paginationColor.perPage" :current-page="paginationColor.page"
                          :fields="fieldColos" :items="compDataColors" responsive="sm" show-empty empty-text="Nenhuma cor encontrada">
                          <template #table-busy>
                            <div class="text-center my-2">
                              <b-spinner class="align-middle mr-1"></b-spinner>
                              <strong>Carregando...</strong>
                            </div>
                          </template>
                          <template #cell(index)="data">
                            {{ data.index + 1 }}
                          </template>

                          <template #cell(acoes)="data">
                            <b-button variant="primary" size="sm" @click="onSelectColor(data.item)">
                              Selecionar
                            </b-button>
                          </template>
                        </b-table>
                      </div>
                    </b-col>
                  </b-row>
                </app-collapse-item>
              </app-collapse>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <b-form-radio-group
                  v-model="uploadType"
                  :options="[
                    { text: 'Upload de Arquivo', value: 'file' },
                    { text: 'URL da Web', value: 'url' }
                  ]"
                  name="upload-type"
                ></b-form-radio-group>
              </b-form-group>

              <b-form-group>
                <b-form-file
                    v-if="uploadType === 'file'"
                    v-model="currentImage.caminho"
                    ref="refCaminho"
                    placeholder="Escolha um arquivo ou arraste-o aqui..."
                    drop-placeholder="Solte o arquivo aqui..."
                    accept="image/*"
                    @change="changeImg($event)"
                ></b-form-file>

                <b-form-input
                  v-else
                  v-model="imageUrl"
                  placeholder="Digite a URL da imagem..."
                  @input="loadImageFromUrl"
                ></b-form-input>
              </b-form-group>
            </b-col>

          </b-row>
        </b-col>
        <b-col cols="12" sm="6" class="d-flex justify-content-center">
          <b-form-group>
            <div class="molde-img">
              <b-img
                  v-if="imagemPresenter !== ''"
                  :src="imagemPresenter"
                  fluid alt="Responsive image"
                  width="261"
                  height="350"
                  style="max-width: 350px; max-height: 261px;min-width: 350px; min-height: 261px;"
              />
              <b-img
                  v-else
                  :src="imagemPadrao"
                  fluid
                  alt="Responsive image"
                  width="261"
                  height="350"
                  style="max-width: 350px; max-height: 261px;min-width: 350px; min-height: 261px;"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>
<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import SlsEmbalagService from '@/services/SistemaDKP/sls-embalag.service';
import SlsCorService from '@/services/SistemaDKP/sls-cor.service';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';

const slsEmbalagService = new SlsEmbalagService();
const slsCorService = new SlsCorService();
export default {
  components: {
    AppCollapse,
    AppCollapseItem,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        des_cor: null,
        des_marca: null,
      }),
    },
  },
  data() {
    return {
      imagemPadrao: IMAGEM_PADRAO,
      selected: [],
      ordem: null,
      imagemPresenter: null,
      imagemFile: null,
      embalagens: [],
      nameColor: null,
      cod_cor: null,
      searchColor: '',
      showCollapse: false,
      colorLoading: false,
      fieldColos: [
        { key: 'cdn_cor', label: 'Código da cor' },
        { key: 'des_cor', label: 'Descrição da cor' },
        { key: 'acoes', label: 'Ações' },
      ],
      dataColors: [],
      uploadType: 'file',
      imageUrl: '',
    };
  },
  watch: {
    currentImage: {
      handler(newValue) {
        if (newValue.cdn_cor && newValue.des_cor) {
          this.cod_cor = typeof newValue.cdn_cor === 'object' ? newValue.cdn_cor.cdn_cor : newValue.cdn_cor;
          this.nameColor = newValue.des_cor;
        }
        if (newValue.cdn_embalag && newValue.des_embalag) {
          this.currentImage.cdn_embalag = {
            cdn_embalag: typeof newValue.cdn_embalag === 'object' ? newValue.cdn_embalag.cdn_embalag : newValue.cdn_embalag,
            des_embalag: typeof newValue.cdn_embalag === 'object' ? newValue.cdn_embalag.des_embalag : newValue.des_embalag,
          };
        }
        if (typeof newValue.caminho === 'object') {
          this.imagemPresenter = newValue.caminho_base64;
          newValue.caminho = newValue.caminho;
          this.imagemFile = newValue.caminho;
        }
      },
      deep: false,
    },
  },
  computed: {
    compDataColors() {
      return this.dataColors;
    },
    paginationColor: {
      get() {
        return this.$store.getters['slsCor/getFilters'];
      },
      set(val) {
        this.$store.commit('slsCor/setFilters', val);
      },
    },
    currentImage: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    onSelectColor(cor) {
      this.currentImage.cdn_cor = cor;
      this.nameColor = cor.des_cor;
      this.cod_cor = cor.cdn_cor;
      this.showCollapse = false;
    },
    async listarEmbalagens(term) {
      this.$store.commit('slsEmbalagem/setFilters', { q: term, ...this.$store.state.slsEmbalagem.filters });
      await slsEmbalagService.findAll().then((response) => {
        this.embalagens = response;
      });
    },
    async searchCor() {
      const codCor = this.cod_cor;
      await slsCorService.index({ cdn_cor: codCor, perPage: 5 }).then((response) => {
        if (response.length === 0) return this.nameColor = '';
        this.nameColor = response[0].des_cor;
      });
    },
    async listFilterCodCor(cdnCor) {
      await slsEmbalagService.findAll({ cdn_cor: cdnCor }).then((response) => {
        this.currentImage.cdn_embalag = response[0].cdn_embalag;
      });
    },
    saveImagem(e) {
      const dataCdnCor = {
        cdn_cor: this.currentImage.cdn_cor && typeof this.currentImage.cdn_cor === 'object' ? this.currentImage.cdn_cor.cdn_cor : this.currentImage.cdn_cor,
        des_cor: this.nameColor,
      };
      this.$emit('addImagem', {
        ...e,
        ...dataCdnCor,
        cdn_embalag: this.currentImage.cdn_embalag.cdn_embalag,
        des_embalag: this.currentImage.cdn_embalag.des_embalag,
      });
      this.resetData();
    },
    resetData() {
      this.$emit('closeModal');
      this.currentImage = {
        imagem_principal: 0,
        exibe_cores: 0,
        ordem: null,
        des_marca: null,
        cdn_embalag: null,
        cdn_cor: null,
        caminho: null,
        caminho_base64: null,
      };
      this.imagemPresenter = null;
      this.nameColor = null;
      this.searchColor = '';
      this.showCollapse = false;
      this.cod_cor = null;
      this.uploadType = 'file';
      this.imageUrl = '';
    },
    async listarCores(pagination) {
      if (!this.searchColor || this.searchColor.trim() === '') {
        this.dataColors = [];
        this.colorLoading = false;
        return;
      }

      this.colorLoading = true;
      try {
        const response = await slsCorService.index({
          q: this.searchColor,
          ...pagination,
        });
        this.dataColors = response;
      } catch (error) {
        console.error('Erro ao listar cores:', error);
      } finally {
        this.colorLoading = false;
      }
    },
    changeImg(event) {
      event.preventDefault();
      let file = null;
      if (event.dataTransfer) {
        file = event.dataTransfer.files[0];
      } else {
        file = event.target.files[0];
      }

      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagemPresenter = e.target.result;
          this.currentImage.caminho_base64 = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    async loadImageFromUrl() {
      if (!this.imageUrl) return;

      try {
        const response = await fetch(this.imageUrl);
        const blob = await response.blob();

        const file = new File([blob], 'image.jpg', { type: blob.type });

        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagemPresenter = e.target.result;
          this.currentImage.caminho_base64 = e.target.result;
          this.currentImage.caminho = this.imageUrl;
        };
        reader.readAsDataURL(file);
      } catch (error) {
        console.error('Erro ao carregar imagem:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao carregar a imagem.',
            text: 'Tente novamente ou aguarde a imagem ser cadastrada no sistema.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
      }
    },
  },
  async mounted() {
    await this.listarCores();
    await this.listarEmbalagens();
  },
};
</script>
